export default "__VITE_ASSET__0xhRWnOf__"